<template>
  <section class="nav-menu">
    <b-tabs
      v-model="activeTab"
      expanded
      type="is-centered"
      class="is-fullwidth is-info  block nav-menu__tabs"
    >
      <b-tab-item :label="localization('app-layers','Layers')">
        <vector-list></vector-list>
      </b-tab-item>
      <b-tab-item :label="localization('app-blocks','Blocks')">
        <group-list></group-list>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import VectorList from "./components/vectors/vector-list.component";
import GroupList from "./components/group/group-list.component";

export default {
  data() {
    return {
      activeTab: 1
    };
  },
  components: {
    "vector-list": VectorList,
    "group-list": GroupList
  }
};
</script>
<style lang="scss" >
.nav-menu {
  .tab-content {
    padding: 1rem 3px;
    text-align: center;
  }
  .tabs ul {
    margin-left: 0;
    font-size: 0.9rem;
  }
  .tabs li {
    text-transform: capitalize;
  }
  .tabs a {
    border-bottom-width: 3px;
    border-bottom-color: transparent;
    color: #171e48;
    opacity: 0.5;
    font-family: Barlow-SemiBold !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19px !important;
    padding-bottom:17px; 
  }
  .tabs li.is-active a {
    opacity: 1;
    color: #171e48;
    border-bottom-width: 3px;
    border-bottom-color: #5c7ef7;
  }
}

.content .nav-menu li + li {
  margin-top: 0 !important;
}
</style>
